<mat-toolbar class="dPToolbar">
  <span>Download Status</span>
  <span class="alignRight"></span>
  <div (click)="closePopup()" class="imgSize"><img alt="img" src="./assets/Cross_NEG.svg"></div>
</mat-toolbar>

<div *ngIf="!this._data.downloadStatus">
  <div class="alignCenter">
    <mat-spinner class="objSize"></mat-spinner>
  </div>
  <div class="text alignCenter">Downloading...</div>
</div>

<div *ngIf="this._data.downloadStatus">

  <div class="alignCenter">
    <img alt="img" class="objSize" src="./assets/Download_Complete_Icon.svg">
  </div>
  <div class="text alignCenter">Download Complete</div>
</div>
